import { ApiQueryParams, DefaultQueryParams, PaginatedResponse } from '@frontend/api-utils';
import { Application, Feature, FeatureTarget, Functionality } from '@frontend/functionality/types';

export function checkFeatureRoute(feature: Feature, routeLicenseResult: { appEnabled: boolean; features: Feature[] } | null): boolean {
    if (!routeLicenseResult) return true;
    return routeLicenseResult.features.includes(feature);
}

export function checkLicenseRoutes(functionalities: Functionality[], application: Application): { appEnabled: boolean; features: Feature[] } {
    const features = functionalities
        .filter((f) => f.application === application)
        .filter((f) => f.target === FeatureTarget.PLATFORM)
        .map((f) => f.feature);
    return { appEnabled: features.length > 0, features };
}

export async function recursiveFetch<T>(
    fetch: (arg?: ApiQueryParams<DefaultQueryParams | string | number>) => Promise<PaginatedResponse<T>>,
    size = 100
): Promise<T[]> {
    const firstResponse = await fetch({ index: '0', size: size.toString() });
    const totalPages = Math.ceil(firstResponse.count / size);

    if (totalPages === 1) {
        return firstResponse.results;
    }

    const pagePromises = Array.from({ length: totalPages - 1 }, (_, i) => fetch({ index: (i + 1).toString(), size: size.toString() }));

    const responses = await Promise.all(pagePromises);
    return [firstResponse, ...responses].flatMap((r) => r.results);
}
